import { schema as schemas } from 'normalizr'
import qs from 'qs'
import { CallApi } from '@signavio/kraken'

export const collection = 'dictionaryCategories'
export const dictionaryCategorySchema = new schemas.Entity(collection)

export const schema = new schemas.Array(dictionaryCategorySchema)

type RequestParamsType = { id: string; searchTerm: string }

export const fetch =
  (callApi: CallApi, apiBase: string) =>
  ({ id, searchTerm }: RequestParamsType) => {
    const params = qs.stringify(
      { filter: searchTerm },
      { addQueryPrefix: true }
    )

    return callApi(
      `${apiBase}/dictionary/connectors/${id}/actions/find${params}`,
      schema
    )
  }
